import api from './api';
import { decryptString } from '../utils/helper';

/**
 * @description 获取ossInfo
 * @param params ticket_id
 * @return { Promise }
 */
export const getOssInfoAES = async () => {
  const protocol = window.location.protocol;
  const auth = await api.get(`${protocol}//flush.hexinedu.com/api/aliyun/ak/get/v3/`);
  // 解密
  auth.access_secret = decryptString(auth.access_secret);
  return auth;
};
